import React from "react"
import PropTypes from "prop-types"
import styled from "@emotion/styled"
import Users from "../../../icons/svg/Users"
import Img from "gatsby-image"
import { breakpoints, color } from "../../../utils/style"

const Wrapper = styled("div")`
  .h1 {
    justify-content: flex-start;
    svg {
      flex-basis: 10%;
    }
  }
  .top-steps-text,
  .bottom-steps-text {
    margin-bottom: 32px;
    p {
      font-size: 16px;
      line-height: 24px;
    }
  }
  .item {
    display: flex;
    flex-flow: row wrap;
    border: 4px solid ${color.red};
    border-radius: 8px;
    box-sizing: border-box;
    box-shadow: 0 8px 24px rgba(104, 0, 0, 0.3);
    backdrop-filter: blur(12px);
    background: ${color.transparentDarkRed6};
    padding: 30px 35px;
    margin-bottom: 24px;
    .gatsby-image-wrapper {
      width: 100%;
      max-width: 100px;
      margin: 0 auto;
    }
    .title {
      font-weight: 600;
      font-size: 18px;
      line-height: 24px;
      text-transform: uppercase;
    }
    .description {
      font-size: 16px;
      line-height: 24px;
      white-space: pre-wrap;
    }
  }
  .col-left {
    flex-basis: 15%;
    padding-right: 10px;
    text-align: center;
  }
  .col-right {
    flex-basis: 85%;
  }
  @media (max-width: ${breakpoints.tl}) {
    .col-left {
      flex-basis: 25%;
    }
    .col-right {
      flex-basis: 75%;
    }
  }
  @media (max-width: ${breakpoints.md}) {
    .col-left {
      flex-basis: 30%;
    }
    .col-right {
      flex-basis: 70%;
    }
  }
  @media (max-width: ${breakpoints.sm}) {
    .h1 {
      svg {
        flex-basis: 35%;
      }
    }
    .item {
      padding: 24px 16px;
    }
    .col-left {
      flex-basis: 100%;
      padding: 0 0 20px 0;
    }
    .col-right {
      flex-basis: 100%;
    }
  }
`

const StepToRegister = ({ steps, top_text }) => {
  return (
    <Wrapper>
      <h2 className="h1 with-icon rich-design">
        <Users />
        <span>
          ขั้นตอนการสมัครสมาชิก คาสิโนออนไลน์ Royal1688 กับ Royal-1688.net
        </span>
      </h2>
      {top_text && (
        <div className="top-steps-text">
          <p dangerouslySetInnerHTML={{ __html: top_text }} />
        </div>
      )}
      <div className="steps-wrapper">
        {steps?.map(item => {
          const localFile = item?.localFile || {}

          return (
            <div key={item.path} className="item">
              <div className="col-left">
                <div>
                  {localFile?.childImageSharp &&
                    localFile?.childImageSharp?.fluid && (
                      <Img
                        fluid={localFile.childImageSharp.fluid}
                        alt={item.alt_text ? item.alt_text : "royal-1688.net"}
                        fadeIn={false}
                        loading="eager"
                      />
                    )}
                </div>
                <div>
                  <p
                    className="title"
                    dangerouslySetInnerHTML={{ __html: item?.acf?.slide_title }}
                  />
                </div>
              </div>
              <div className="col-right">
                <p
                  className="description"
                  dangerouslySetInnerHTML={{
                    __html: item?.acf?.slide_description,
                  }}
                />
              </div>
            </div>
          )
        })}
      </div>
    </Wrapper>
  )
}

StepToRegister.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      acf: PropTypes.shape({
        slide_description: PropTypes.string,
        slide_title: PropTypes.string,
        slide_url: PropTypes.string,
      }),
      alt_text: PropTypes.string,
      path: PropTypes.string,
      title: PropTypes.string,
    })
  ),
  top_text: PropTypes.string,
}

StepToRegister.defaultProps = {
  steps: [],
  top_text: "",
}

export default StepToRegister
